import React from 'react'
import { Container, Card, SectionHeading, ButtonLink } from '../components/atoms.jsx'
import { SeoManager } from '../components/content.jsx'

export function NotFoundPage() {
  return (
    <>
      <SeoManager
        title="404 · Siden blev ikke fundet | Helseklinikken"
        description="Siden findes ikke."
        canonical="https://helselarsen.dk/404/"
      />
      <main className="py-16 lg:py-24">
        <Container>
          <Card className="mx-auto max-w-2xl space-y-6 text-center">
            <SectionHeading eyebrow="404" title="Siden blev ikke fundet" description="Vi kunne ikke finde den side, du søgte efter." align="center" />
            <ButtonLink href="/" variant="primary">Til forsiden</ButtonLink>
          </Card>
        </Container>
      </main>
    </>
  )
}
